import React, { useEffect } from "react";
import { InsightsSection } from "../../components/common";
import { TestimonialSection } from "../../components/home";
import {
  ProgramDetailsSection,
  ProgramsHeroSection,
} from "../../components/programs";
import institutionData from "../../data/institutionData.json";
import programData from "../../data/programData.json";
import "./program.css";

export default function Program({ initialData }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main className="programs-page">
      <ProgramsHeroSection data={programData.hero} />
      <ProgramDetailsSection data={programData.details} />
      <TestimonialSection   testimonials={programData.testimonials} />
      <InsightsSection initialData={initialData}/>
    </main>
  );
}
